import store from '@/stores/'
import UNIQUE from '@/common/unique'

const defaultValue = 'rating'
const langValue = function () {
  const obj = Object.assign({}, store.state.setting.lang.langValue)
  Object.keys(obj).forEach(function (x) {
    obj[x] = defaultValue
  })
  return obj
}

export default {
  id: 'rate',
  name: 'rate',
  type: 'action',
  moduleName: 'editor_module_rate',
  dataSet: {
    mods: 'rate',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'rate',
        value: ''
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'fullsize',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: {
      name: 'rate',
      isRequired: true,
      label: langValue(),
      labelValue: defaultValue,
      max: 5,
      rateValue: 4,
      type: 'star', // star, heart, smile, circle, square
      color: 'rgba(255,188,0,1)',
      labelFontSize: 'default',
      valueFontSize: 'default'
    },
    detail: null
  }
}
